/**
 * Copy user-facing del embudo membership (dual CTA, video landing, Mux overlay).
 * Nunca mencionar Telegram en strings visibles — marca: Membresía Exclusiva / Exclusive Membership.
 *
 * ES/EN canónicos: shared/dualCtaIntlFallback (mismo que DB seed + contrato Stripe).
 */

import {
  INTL_DUAL_CTA_DEFAULT_VIP_LABEL_EN,
  INTL_DUAL_CTA_DEFAULT_VIP_LABEL_ES,
} from "@/lib/dualCtaIntlFallback";

export type MembershipCtaLang = "es" | "en" | "pt" | "fr" | "de" | "it" | "nl";

export const MEMBERSHIP_VIP_CTA: Record<MembershipCtaLang, string> = {
  // Derivados del contrato dual (shared/dualCtaIntlFallback) — una sola fuente
  // de verdad con admin/DB/público. EN = "Exclusive Membership".
  es: INTL_DUAL_CTA_DEFAULT_VIP_LABEL_ES,
  en: INTL_DUAL_CTA_DEFAULT_VIP_LABEL_EN,
  pt: "Membro Exclusivo",
  fr: "Membre Exclusif",
  de: "Exklusives Mitglied",
  it: "Membro Esclusivo",
  nl: "Exclusief Lid",
};

/** Overlay video / pantallas que usan plural (ej. BioTemplatePremiumSimple). */
export const MEMBERSHIP_VIP_CTA_PLURAL: Record<MembershipCtaLang, string> = {
  es: "Miembros Exclusivos",
  en: "Exclusive Members",
  pt: "Membros Exclusivos",
  fr: "Membres Exclusifs",
  de: "Exklusive Mitglieder",
  it: "Membri Esclusivi",
  nl: "Exclusieve Leden",
};

/** Botón secundario free — sin nombrar Telegram ni “grupo/canal”. */
export const MEMBERSHIP_FREE_CTA: Record<MembershipCtaLang, string> = {
  es: "Acceso gratuito",
  en: "Free access",
  pt: "Acesso gratuito",
  fr: "Accès gratuit",
  de: "Kostenloser Zugang",
  it: "Accesso gratuito",
  nl: "Gratis toegang",
};

/** Prefijo opcional bajo el VIP en layouts dual (internationalDual.ctaFree). */
export const MEMBERSHIP_FREE_CTA_PREFIX: Record<MembershipCtaLang, string> = {
  es: "o accedé gratis",
  en: "or get free access",
  pt: "ou acesse grátis",
  fr: "ou accès gratuit",
  de: "oder gratis Zugang",
  it: "o accesso gratuito",
  nl: "of gratis toegang",
};

function langBase(raw: string | null | undefined): MembershipCtaLang {
  const base = (raw ?? "es").toLowerCase().split("-")[0];
  const supported: MembershipCtaLang[] = [
    "es",
    "en",
    "pt",
    "fr",
    "de",
    "it",
    "nl",
  ];
  return (supported.includes(base as MembershipCtaLang) ? base : "en") as MembershipCtaLang;
}

export function membershipVipCta(lang: string | null | undefined): string {
  return MEMBERSHIP_VIP_CTA[langBase(lang)];
}

export function membershipVipCtaPlural(lang: string | null | undefined): string {
  return MEMBERSHIP_VIP_CTA_PLURAL[langBase(lang)];
}

export function membershipFreeCta(lang: string | null | undefined): string {
  return MEMBERSHIP_FREE_CTA[langBase(lang)];
}

export function membershipFreeCtaPrefix(lang: string | null | undefined): string {
  return MEMBERSHIP_FREE_CTA_PREFIX[langBase(lang)];
}

/** Admin / validación: ningún label user-facing puede contener “telegram”. */
export const MEMBERSHIP_LABEL_TELEGRAM_RE = /telegram/i;